import React from 'react';
// @ts-ignore
import Helper from 'app/modules/Helper';
import classnames from 'classnames';
import CustomScroll from 'react-custom-scroll';
import { connect } from 'react-redux';
import { togglePreventEnter } from '../../../actions/baseActions';

const times: string[] = [
	'00',
	'01',
	'02',
	'03',
	'04',
	'05',
	'06',
	'07',
	'08',
	'09',
	'10',
	'11',
	'12',
	'13',
	'14',
	'15',
	'16',
	'17',
	'18',
	'19',
	'20',
	'21',
	'22',
	'23',
];
type TimePickerProps = {
	selected: string;
	areDatesEqual?: boolean;
	selectedFromTime: string;
	selectedToTime: string;
	openedInput: string;
	togglePreventEnter: (toggle: boolean) => void;
	onSelect: (selected: string) => void;
};
type TimePickerState = {
	focusedIndex: number;
};

class TimePicker extends React.Component<TimePickerProps, TimePickerState> {
	constructor(props: TimePickerProps) {
		super(props);
		this.state = {
			focusedIndex: -1,
		};
	}

	componentDidMount() {
		const selected = this.props.selected;
		times.forEach((item, key) => {
			if (selected === item + ':00') {
				this.setState({
					focusedIndex: key,
				});
			}
		});

		document.addEventListener('keydown', this.handleKeyboard);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleKeyboard);
	}

	handleKeyboard = (e: KeyboardEvent) => {
		e.preventDefault();
		switch (e.keyCode) {
			case 13:
				this.enterEvent();
				break;
			case 38:
				this.pageUpEvent();
				break;
			case 40:
				this.pageDownEvent();
				break;
			default:
				break;
		}
	};

	enterEvent = () => {
		this.props.togglePreventEnter(true);
		const focusedIndex = this.state.focusedIndex;
		if (focusedIndex === -1) {
			return;
		}
		times.forEach((item, key) => {
			if (focusedIndex === key) {
				this.props.onSelect(item + ':00');
			}
		});
	};

	pageUpEvent = () => {
		if (this.state.focusedIndex === 0) {
			return;
		}
		this.setState({
			focusedIndex: this.state.focusedIndex - 1,
		});
	};

	pageDownEvent = () => {
		if (this.state.focusedIndex + 1 === times.length) {
			return;
		}
		this.setState({
			focusedIndex: this.state.focusedIndex + 1,
		});
	};

	render() {
		const { onSelect } = this.props;
		const { focusedIndex } = this.state;

		return (
			<div className="timepicker">
				<div className="times-list">
					<div className="times">
						<CustomScroll scrollTo={focusedIndex * 48 - 100}>
							<div style={{ maxHeight: '350px' }}>
								{times.map((item, key) => {
									return (
										<div
											onClick={() => onSelect(item + ':00')}
											className={classnames('item', {
												selected: focusedIndex === key,
											})}
											key={key}
										>
											{item === '12' ? Helper.trans('keywords.noon') : item + ':00'}
										</div>
									);
								})}
							</div>
						</CustomScroll>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state: any) => ({
	selectedFromTime: state.car.selectedFromTime,
	selectedToTime: state.car.selectedToTime,
	openedInput: state.base.openedInput,
});

export default connect(mapStateToProps, { togglePreventEnter })(TimePicker);
